import { AnimatePresence } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { updateState, updateStateAttribute } from '../../helpers/helper';
import CDropdownPanel from '../CDropdownPanel';

export interface IXDDropdownBroadcastedComponents {
  closeDropdown?: () => void;
}

interface props {
  button: React.ReactNode;
  children: React.ReactNode;
  /**
   * @deprecated
   */
  topShift?: string;
  closeOnAnyClick?: boolean;
  onClose?: () => void;
  windowAnchor?: 'left' | 'right';
  asModal?: boolean;
  /**
   * @deprecated
   */
  usePortal?: boolean;
  onUpdatedBroadcastedComponents?: (components: IXDDropdownBroadcastedComponents) => void;
  style?: Partial<Pick<React.CSSProperties, 'width'> & { left: number; top: number }>;
}

interface State {
  showDropdown: boolean;
}

/**
 * TODO: Rename to CDropdown
 * @param props
 * @constructor
 */
export default function XDDropdown(props: props) {
  const [state, setState] = useState<State>({ showDropdown: false });
  const ref = useRef<HTMLDivElement>(null);
  const handleHide = () => {
    if (state.showDropdown) {
      updateState<State>({ showDropdown: false }, state, setState);
      if (props.onClose) props.onClose();
    }
  };

  const panel = (
    <AnimatePresence>
      {state.showDropdown && (
        <CDropdownPanel
          onHide={handleHide}
          closeOnAnyClick={props.closeOnAnyClick !== false}
          openDown={(ref.current?.getBoundingClientRect().top ?? 0) <= window.innerHeight * 0.5}
          parentRef={ref}
          windowAnchor={props.windowAnchor ?? 'right'}
          asModal={props.asModal ?? false}
          style={props.style}
          usePortal
        >
          {props.children}
        </CDropdownPanel>
      )}
    </AnimatePresence>
  );

  useEffect(() => {
    if (state.showDropdown) {
      props.onUpdatedBroadcastedComponents?.({
        closeDropdown: () => {
          updateStateAttribute<State>({ showDropdown: false }, setState);
        }
      });
    } else {
      props.onUpdatedBroadcastedComponents?.({});
    }
  }, [state.showDropdown]);

  return (
    <div
      ref={ref}
      className={'relative z-10 overflow-visible'}
      onClick={(ev) => {
        ev.preventDefault();
      }}
    >
      {createPortal(panel, document.body)}
      {!state.showDropdown && (
        <div
          onClick={(ev) => {
            ev.preventDefault();
            updateStateAttribute<State>({ showDropdown: true }, setState);
          }}
        >
          {props.button}
        </div>
      )}
      {state.showDropdown && (
        // Temporary hack to fix race issue.
        <div
          onClick={(ev) => {
            ev.preventDefault();
            updateStateAttribute<State>({ showDropdown: false }, setState);
          }}
        >
          {props.button}
        </div>
      )}
    </div>
  );
}
